import { ServiceBase } from "../shared";

export default class ProviderValidationService extends ServiceBase {

  public async queueProviderValidationJob(providerSetId: number, providerSetVersionId: number): Promise<number> {
    return await this.makePost<number>(`providervalidation/${providerSetId}/${providerSetVersionId}/queue-validation`);
  }

}